import { Task } from '../task/task.model';

export class InfoRequestTask extends Task {
    fromRole: 'fundingManager' | 'fundingDesk' | 'lender';
    taskType: 'question' | 'contracts' | 'resubmission';

}
